export const loadGoogleMaps = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if the script is already loaded
    if (
      typeof window !== "undefined" &&
      window.google &&
      window.google.maps &&
      window.google.maps.places
    ) {
      resolve();
      return;
    }

    const callbackName = "initGoogleMapsCallback";
    (window as any)[callbackName] = () => {
      resolve();
      delete (window as any)[callbackName];
    };

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${
      import.meta.env.VITE_GOOGLE_API_KEY
    }&libraries=places&loading=async&callback=${callbackName}`;
    script.async = true;
    script.defer = true;

    script.onerror = (event) => {
      let error: Error;
      if (event instanceof ErrorEvent) {
        error = event.error ?? new Error(event.message);
      } else {
        error = new Error("Google Maps script failed to load");
      }
      reject(error);
      delete (window as any)[callbackName];
    };

    document.body.appendChild(script);
  });
};
